import { AudienceCatalogRoot, ScreenRoot } from "types";

export const AudienceCatalogRootDefinition: ScreenRoot = {
  name: AudienceCatalogRoot,
  routePath: ["/audience-catalog/*"],
  accessPath: "audienceCatalog",
};
